import React, { SelectHTMLAttributes, forwardRef } from "react";

import "./select.css";

export interface SelectUIProps {
    /**
     * Color for the chevron icon.
     */
    uiColor?: string;
    /**
     * Disable the select (mirrors native disabled but keeps existing prop).
     */
    uiDisabled?: boolean;
}

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & SelectUIProps;

const Select = forwardRef<HTMLSelectElement, SelectProps>((props, ref) => {
    const { uiColor, uiDisabled, className, style, disabled, ...other } = props;

    const rootClassName = [
        "select-root",
        uiDisabled || disabled ? "select-root--disabled" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const inlineStyle: any = {
        ...style,
    };

    if (uiColor) {
        inlineStyle["--select-chevron-color" as any] = uiColor;
    }

    return (
        <div className={rootClassName} style={inlineStyle} aria-disabled={uiDisabled || disabled}>
            <select
                {...other}
                ref={ref}
                className="select-root__select"
                disabled={uiDisabled || disabled}
            />
            <svg
                className="select-root__chevron"
                focusable={false}
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 40 40"
            >
                <g>
                    <path d="m37.6 18l-16.6 16.6q-0.4 0.4-1 0.4t-1-0.4l-16.6-16.6q-0.4-0.4-0.4-1t0.4-1l3.7-3.7q0.5-0.4 1-0.4t1 0.4l11.9 11.9 11.9-11.9q0.4-0.4 1-0.4t1 0.4l3.7 3.7q0.4 0.4 0.4 1t-0.4 1z" />
                </g>
            </svg>
        </div>
    );
});

Select.displayName = "Select";

export default Select;
